ACC.productconfig = {
  bindAll: function() {
    $(document).on('click', '.ph-decisionpageconfigbutton', this.generateConfigurationPopup);
    $(document).on('click', '.ph-pdpconfigbutton', this.generateConfigurationPopupPdp);
    $(document).on('click', '.ph-configureproduct__close', function() {
      $.colorbox.close();
    });
    $(document).on('change', '#languageConfigSelect', function() {
      ACC.productconfig.redefineSelecboxProperties(true, false);
    });
    $(document).on('change', '.ph-common-configselect', function() {
      ACC.productconfig.applySelectedVariants(false);
    });
    $(document).on('click', '.ph-configuration-popup .ph-dspagechbox-languageterms', function() {
      ACC.productconfig.applySelectedVariants(false);
    });
    $(document).on('click', '.ph-configpopup__apply', function() {
      ACC.productconfig.applySelectedVariants(true);
    });
    $(document).on('click', '.ph-configpopup__cancel', function() {
      $.colorbox.close();
    });
  },
  generateConfigurationPopup: function() {
    var productCode = $(this).attr('data-productcode');

    $('#currentProductCode').val(productCode);

    ACC.productconfig.redefineSelecboxProperties(false, false);

    var $addedItem = $('#decisionpageitem' + productCode),
        addedItemImageUrl = $addedItem.find('.ph-decisionpage__image').find('.ph-freqorderedproduct__image').attr('src'),
        addedItemProductUrl = $addedItem.find('.ph-decisionpage__content').find('.productMainLink').attr('href'),
        addedItemProductName = $addedItem.find('.ph-productname').text(),
        addedItemProductCtn = $addedItem.find('.ph-productname').attr('data-prod');

    var popupContentTemplate = '<a href="' + addedItemProductUrl + '"><div class="ph-p-0 ph-text-center"><img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage" src="" data-src="' + addedItemImageUrl + '" alt="' + addedItemProductName + '" title="' + addedItemProductName + '"></div></a>';

    $('#decisionPageConfigProducts').html('<div class="ph-col-12 ph-col-md-3  ph-float-left ph-aedleft_image  ph-pr-0">' + popupContentTemplate + '</div><div class=" ph-col-12  ph-col-md-9 ph-float-left ph-aedright_content ph-pl-2"><div class="ph-prodname"><a href="' + addedItemProductUrl + '">' + addedItemProductName + '</a></div><div class="ph-productctn">' + addedItemProductCtn + '</div><div class="ph-aed-data ph-col-12 ph-p-0 ph-float-left"></div></div>');

    var changeUrl = encodeURI($('.ph-getCharacteristicsUrl').text() + '?productCode=' + productCode);

    $.getJSON(changeUrl, ACC.productconfig.generateSelectBox);
  },
  generateConfigurationPopupPdp: function() {
    var productCodePdp = $(this).attr('data-productcode');

    $('#currentProductCode').val(productCodePdp);

    ACC.productconfig.redefineSelecboxProperties(false, false);

    var $addedItem = $(document).find('#productDetailUpdateable'),
        addedItemImageUrl = $addedItem.find('.ph-prod_image_main').find('li:first-child>img').attr('src'),
        addedItemProductUrl = window.location.href,
        addedItemProductName = $addedItem.find('.ph-pdp_product_name').text(),
        addedItemProductCtn = productCodePdp;

    var popupContentTemplate = '<a href="' + addedItemProductUrl + '"><div class="ph-p-0 ph-text-center"><img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage" src="" data-src="' + addedItemImageUrl + '" alt="' + addedItemProductName + '" title="' + addedItemProductName + '"></div></a>';

    $('#decisionPageConfigProducts').html('<div class="ph-col-12 ph-col-md-3  ph-float-left ph-aedleft_image  ph-pr-0">' + popupContentTemplate + '</div><div class=" ph-col-12  ph-col-md-9 ph-float-left ph-aedright_content ph-pl-2"><div class="ph-prodname"><a href="' + addedItemProductUrl + '">' + addedItemProductName + '</a></div><div class="ph-productctn">' + addedItemProductCtn + '</div><div class="ph-aed-data ph-col-12 ph-p-0 ph-float-left"></div></div>');

    var changeUrl = encodeURI($('.ph-getCharacteristicsUrl').text() + '?productCode=' + productCodePdp);

    $.getJSON(changeUrl, ACC.productconfig.generateSelectBox);
  },
  redefineSelecboxProperties: function(loadColorBox, prefill) {
    var $this = $('#decisionPageProductConfiguration').find('#languageConfigSelect');

    $('.ph-firstproduct-language__validation').hide();
    $('.ph-existinglanguage__validation').hide();
    $('.ph-nonlocalanguage__validation').hide();
    $('.ph-language__termsvalidation').hide();
    $('.ph-configuration-popup').find('.ph-dspagechbox-languageterms').prop('checked', false);
    $('#termsCheckboxEnabled').val('false');

    if ($this.length > 0) {
      ACC.productconfig.languageMsgShowing($this.val());

      if ($this.find('option:selected').attr('isdealer') === 'true') {
        $('.ph-nonlocalanguage__validation').show();

        if (prefill === true) {
          $('.ph-configuration-popup').find('.ph-dspagechbox-languageterms').prop('checked', true);
        }

        $('#termsCheckboxEnabled').val('true');
      }

      if (loadColorBox) {
        $.colorbox.load();
      }
    }
  },
  languageMsgShowing: function(langSelectBoxValue) {
    var allLangMsg = $('#decisionPageProductConfiguration').find('.ph-firstproduct-language__validation');

    if (String($('#existingAedLangCount').val()) === '0') {
      allLangMsg.show();
    } else {
      var existingAedLang = $('#existingAedLang').val();

      if (langSelectBoxValue !== '' && langSelectBoxValue !== existingAedLang && existingAedLang !== '') {
        allLangMsg.hide();
        $('.ph-existinglanguage__validation').show();
      } else {
        allLangMsg.show();
      }
    }
  },
  processesVariantData: function(data) {
    function compareValue(a, b) {
      if (a.value < b.value) {
        return -1;
      }

      if (a.value > b.value) {
        return 1;
      }

      return 0;
    }

    var returnData = {};

    $.each(data, function(k, v) {
      returnData[k] = v.sort(compareValue);
    });

    return returnData;
  },
  generateSelectBox: function(mapData) {
    ACC.productconfig.configMandatoryText = $('#configMandatoryText').text();
    ACC.productconfig.selectLabel = '<label class=\'ph-aed_select_title\'>';

    var productAllVariants = ACC.productconfig.processesVariantData(mapData.variantMap);

    $('#currentEntryNumber').val(mapData.cartData.totalItems);

    $('#decisionPageConfigProducts').find('.ph-aed-data').html('');

    var optionalMutualVariantsOption = '',
        labelItemOmv = '',
        optMutualCount = 0,
        mandatoryMutualVariantsOption = '',
        labelItemMmv = '',
        mandMutualCount = 0;

    $.each(productAllVariants, function(variantName, productVariantsObject) {
      var productVariants = Object.keys(productVariantsObject).map(function(k) {
        return productVariantsObject[k];
      });

      if (variantName === 'Language' || variantName === 'Localization') {
        ACC.productconfig.languageSelectbox(productVariants);
      } else {
        ACC.productconfig.optionalVariantBuilding(productVariants, variantName);
        ACC.productconfig.mandatoryVariantBuilding(productVariants, variantName);


        var optionalMutualReturned = ACC.productconfig.optionalMutualVariantBuilding(optionalMutualVariantsOption, labelItemOmv, optMutualCount, productVariants);

        optionalMutualVariantsOption = optionalMutualReturned.optionalMutualVariantsOption;
        labelItemOmv = optionalMutualReturned.labelItemOmv;
        optMutualCount = optionalMutualReturned.optMutualCount;


        var mandatoryMutualReturned = ACC.productconfig.mandatoryMutualVariantBuilding(mandatoryMutualVariantsOption, labelItemMmv, mandMutualCount, productVariants);

        mandatoryMutualVariantsOption = mandatoryMutualReturned.mandatoryMutualVariantsOption;
        labelItemMmv = mandatoryMutualReturned.labelItemMmv;
        mandMutualCount = mandatoryMutualReturned.mandMutualCount;
      }
    });

    var labelItem = '';

    if (optionalMutualVariantsOption !== '') {
      labelItem = ACC.productconfig.selectLabel + $('#selectConfiguration').val() + '</label>';

      if (labelItemOmv !== '' && optMutualCount <= 1) {
        labelItem = ACC.productconfig.selectLabel + labelItemOmv + '</label>';
      }

      $('.ph-aed-data').prepend(optionalMutualVariantsOption + '<option selected value=\'\'>' + $('#selectOptionOptional').val() + '</option></select>' + labelItem + '</div>');
    }

    if (mandatoryMutualVariantsOption !== '') {
      labelItem = ACC.productconfig.selectLabel + $('#selectConfiguration').val() + ACC.productconfig.configMandatoryText + '</label>';

      if (labelItemMmv !== '' && mandMutualCount <= 1) {
        labelItem = ACC.productconfig.selectLabel + labelItemMmv + '</label>';
      }

      $('.ph-aed-data').prepend(mandatoryMutualVariantsOption + '<option disabled selected value=\'\'>' + $('#selectOptionMandatory').val() + '</option></select>' + labelItem + '<span class="ph-exclamation-mark"></span></div>');
    }

    $('#decisionPageProductConfiguration').removeClass('hidden');
    ACC.productconfig.configPopupColorbox();
  },
  aedOptionIteration: function(items, options) {
    var optionsHtml = options;

    items.forEach(function(item) {
      var priceFormated = '';

      if (item.description === 'undefined' || item.description === null) {
        item.description = '';
      }

      if (item.name !== 'Language' && item.name !== 'Localization') {
        priceFormated = '&nbsp;(' + item.addPrice.formattedValue + ')&nbsp;';
      }

      optionsHtml = optionsHtml + '<option isdealer=\'' + item.isDealer + '\' itemname=\'' + item.name + '\' itemcode=\'' + item.code + '\' title=\'' + item.description + '\' value=\'' + item.value + '\'>' + item.value + priceFormated + '</option>';
    });

    return optionsHtml;
  },
  languageSelectbox: function(productVariants) {
    var languageVariantsOption = '';
    var localLanguageItems = productVariants.filter(function(productVariant) {
      return productVariant.isDealer !== true && (productVariant.name === 'Language' || productVariant.name === 'Localization') && productVariant.isMandatory === true;
    });
    var nonlocalLanguageItems = productVariants.filter(function(productVariant) {
      return productVariant.isDealer === true && (productVariant.name === 'Language' || productVariant.name === 'Localization') && productVariant.isMandatory === true;
    });
    var localLanguageGroupLabel = $('#localLanguageGroupLabel').val();
    var nonLocalLanguageGroupLabel = $('#nonLocalLanguageGroupLabel').val();
    var labelItem = ACC.productconfig.selectLabel + $('#languageSelectBoxLabel').val() + '</label>';

    languageVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select id="languageConfigSelect" class="ph-mandatory_configselect ph-common-configselect"  isMandatory="true">';

    if (localLanguageItems.length > 0 && nonlocalLanguageItems.length > 0) {
      languageVariantsOption = languageVariantsOption + '<optgroup label=\'' + localLanguageGroupLabel + '\'>';
      languageVariantsOption = ACC.productconfig.aedOptionIteration(localLanguageItems, languageVariantsOption);
      languageVariantsOption = languageVariantsOption + '</optgroup>';

      languageVariantsOption = languageVariantsOption + '<optgroup label=\'' + nonLocalLanguageGroupLabel + '\'>';
      languageVariantsOption = ACC.productconfig.aedOptionIteration(nonlocalLanguageItems, languageVariantsOption);
      languageVariantsOption = languageVariantsOption + '</optgroup>';
    } else if (localLanguageItems.length > 0 && nonlocalLanguageItems.length === 0) {
      languageVariantsOption = ACC.productconfig.aedOptionIteration(localLanguageItems, languageVariantsOption);
    } else if (localLanguageItems.length === 0 && nonlocalLanguageItems.length > 0) {
      languageVariantsOption = ACC.productconfig.aedOptionIteration(nonlocalLanguageItems, languageVariantsOption);
    }

    languageVariantsOption = languageVariantsOption + '<option disabled selected value=\'\'>' + $('#selectOptionMandatory').val() + '</option></select>' + labelItem + '<span class="ph-exclamation-mark"></span></div>';

    $('.ph-aed-data').append(languageVariantsOption);
    ACC.productconfig.validationMsgFunction();
  },
  validationMsgFunction: function() {
    $('.ph-aed-data').append('<div class="ph-firstproduct-language__validation hidden ph-float-left">' + $('#firstProductLanguageMsg').html() + '</div>');
    $('.ph-aed-data').append('<div class="ph-existinglanguage__validation hidden ph-float-left">' + $('#existingLanguageMsgOne').html() + $('#existingLanguageItems').html() + $('#existingLanguageMsgTwo').html() + '</div>');
    $('.ph-aed-data').append('<div class="ph-nonlocalanguage__validation hidden ph-float-left">' + $('#nonLocaLanguageValidationMsg').html() + '</div>');
  },
  optionalVariantBuilding: function(productVariants, variantName) {
    var optionalVariantsOption = '';
    var optionalItems = productVariants.filter(function(productVariant) {
      return productVariant.isMandatory === false && productVariant.mutuallyExclusive === false;
    });

    if (optionalItems.length > 0) {
      var labelItem = ACC.productconfig.selectLabel + variantName + '</label>';

      optionalVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class="ph-optional_configselect ph-common-configselect" isMandatory="false">';
      optionalVariantsOption = ACC.productconfig.aedOptionIteration(optionalItems, optionalVariantsOption);
      optionalVariantsOption = optionalVariantsOption + '<option selected value=\'\'>' + $('#selectOptionOptional').val() + '</option></select>' + labelItem + '</div>';
    }

    $('.ph-aed-data').append(optionalVariantsOption);
  },
  mandatoryVariantBuilding: function(productVariants, variantName) {
    var mandatoryVariantsOption = '';
    var mandatoryItems = productVariants.filter(function(productVariant) {
      return productVariant.isMandatory && productVariant.mutuallyExclusive === false;
    });

    if (mandatoryItems.length > 0) {
      var labelItem = ACC.productconfig.selectLabel + variantName + ACC.productconfig.configMandatoryText + '</label>';

      mandatoryVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class="ph-mandatory_configselect ph-common-configselect"  isMandatory="true">';
      mandatoryVariantsOption = ACC.productconfig.aedOptionIteration(mandatoryItems, mandatoryVariantsOption);
      mandatoryVariantsOption = mandatoryVariantsOption + '<option disabled selected value=\'\'>' + $('#selectOptionMandatory').val() + '</option></select>' + labelItem + '<span class="ph-exclamation-mark"></span></div>';
    }

    $('.ph-aed-data').append(mandatoryVariantsOption);
  },
  optionalMutualVariantBuilding: function(optionalMutualVariantsOptionParam, labelItemOmvParam, optMutualCountParam, productVariants) {
    var returnableValues = [];
    var optionalMutualVariantsOption = optionalMutualVariantsOptionParam;
    var labelItemOmv = labelItemOmvParam;
    var optMutualCount = optMutualCountParam;

    var optionalMutualVariants = productVariants.filter(function(productVariant) {
      return productVariant.mutuallyExclusive && productVariant.isMandatory === false;
    });

    if (optionalMutualVariants.length > 0) {
      optMutualCount = optMutualCount + 1;

      if (labelItemOmv === '') {
        labelItemOmv = optionalMutualVariants[0].name;
      }

      if (optionalMutualVariantsOption === '') {
        optionalMutualVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class=" ph-common-configselect" isMandatory="false">';
      } else {
        optionalMutualVariantsOption = optionalMutualVariantsOption + '</optgroup>';
      }

      optionalMutualVariantsOption = optionalMutualVariantsOption + '<optgroup label=\'' + optionalMutualVariants[0].name + '\'>';
      optionalMutualVariantsOption = ACC.productconfig.aedOptionIteration(optionalMutualVariants, optionalMutualVariantsOption);
      optionalMutualVariantsOption = optionalMutualVariantsOption + '</optgroup>';
    }

    returnableValues.optionalMutualVariantsOption = optionalMutualVariantsOption;
    returnableValues.labelItemOmv = labelItemOmv;
    returnableValues.optMutualCount = optMutualCount;

    return returnableValues;
  },
  mandatoryMutualVariantBuilding: function(mandatoryMutualVariantsOptionParam, labelItemMmvParam, mandMutualCountParam, productVariants) {
    var returnableValues = [];
    var mandatoryMutualVariantsOption = mandatoryMutualVariantsOptionParam;
    var labelItemMmv = labelItemMmvParam;
    var mandMutualCount = mandMutualCountParam;

    var mandatoryMutualVariants = productVariants.filter(function(productVariant) {
      return productVariant.mutuallyExclusive && productVariant.isMandatory;
    });

    if (mandatoryMutualVariants.length > 0) {
      mandMutualCount = mandMutualCount + 1;

      if (labelItemMmv === '') {
        labelItemMmv = mandatoryMutualVariants[0].name;
      }

      if (mandatoryMutualVariantsOption === '') {
        mandatoryMutualVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class=" ph-common-configselect" isMandatory="true">';
      } else {
        mandatoryMutualVariantsOption = mandatoryMutualVariantsOption + '</optgroup>';
      }

      mandatoryMutualVariantsOption = mandatoryMutualVariantsOption + '<optgroup label=\'' + mandatoryMutualVariants[0].name + '\'>';
      mandatoryMutualVariantsOption = ACC.productconfig.aedOptionIteration(mandatoryMutualVariants, mandatoryMutualVariantsOption);
      mandatoryMutualVariantsOption = mandatoryMutualVariantsOption + '</optgroup>';
    }

    returnableValues.mandatoryMutualVariantsOption = mandatoryMutualVariantsOption;
    returnableValues.labelItemMmv = labelItemMmv;
    returnableValues.mandMutualCount = mandMutualCount;

    return returnableValues;
  },

  configPopupColorbox: function() {
    var popupHeight = 'auto',
        maxHeight = '90%';

    if ($(window).width() < 768) {
      popupHeight = '100%';
      maxHeight = '100%';
    }

    $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
    $.colorbox({
      inline: true,
      href: '#decisionPageProductConfiguration',
      height: popupHeight,
      width: '100%',
      maxWidth: 640,
      maxHeight: maxHeight,
      overlayClose: false,
      scrolling: true,
      escKey: false,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('.ph-configureproduct__buttons').css({
          position: 'sticky',
          bottom: '0'
        });
        $('html').addClass('ph-hideoverflow__configpopup');
        $('#cboxContent').addClass('ph-cbox-content');
        $('#cboxLoadedContent').addClass('ph-cbox-loadedcontent');
        $('#cboxLoadingGraphic').hide();
        $('#cboxLoadingOverlay').hide();
        ACC.imgLazyLoad.setImageObserver();
        ACC.common.searchSelectInit();
      },
      onClosed: function() {
        $('html').removeClass('ph-hideoverflow__configpopup');
        $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
      }
    });

    $('#cboxLoadingGraphic').show();
    $('#cboxLoadingOverlay').show();
  },
  applySelectedVariants: function(sendAjax) {
    var isValidationSuccess = true,
        jsonObj = [];

    var termsAndCondition = false,
        acceptedLanguage = '',
        termsError = false;

    $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
    $('.ph-language__termsvalidation').hide();

    if ($('.ph-configuration-popup').find('.ph-dspagechbox-languageterms').is(':checked') && $('#termsCheckboxEnabled').val() === 'true') {
      termsAndCondition = true;
    } else if ($('#termsCheckboxEnabled').val() === 'true') {
      termsError = true;
      isValidationSuccess = false;
    }

    if ($('#languageConfigSelect').length > 0) {
      acceptedLanguage = $('#languageConfigSelect').val();
    }

    $('#decisionPageProductConfiguration').find('.ph-group_selectbox_items select').each(function() {
      var items = {};

      items.value = $(this).val();
      $(this).parent().removeClass('ph-config-errorborder');

      if ($(this).attr('isMandatory') === 'true' && (items.value === '' || items.value === null)) {
        $(this).parent().addClass('ph-config-errorborder');
        isValidationSuccess = false;
      }

      if (items.value !== '') {
        items.code = $(this).find('option:selected').attr('itemcode');
        items.product = $('#currentProductCode').val();
        items.entryNumber = $('#currentEntryNumber').val();

        if ($('#addToCartForm' + $('#currentProductCode').val()).find('.qty').val()) {
          items.quantity = $('#addToCartForm' + $('#currentProductCode').val()).find('.qty').val();
        } else {
          items.quantity = $('#addToCartForm').find('.qty').val();
        }

        items.termsAndCondition = termsAndCondition;
        items.acceptedLanguage = acceptedLanguage;
        jsonObj.push(items);
      }
    });

    if (isValidationSuccess === true && sendAjax === true) {
      ACC.productconfig.sendingSelectedVariants(jsonObj, termsAndCondition, acceptedLanguage);
      $.colorbox.close();
    } else if (isValidationSuccess === false && sendAjax === true) {
      $('.ph-configureproduct__buttons').find('.ph-error-message').show();

      if (termsError) {
        $('.ph-language__termsvalidation').show();
      }
    }
  },
  sendingSelectedVariants: function(jsonObj, termsAndCondition, acceptedLanguage) {
    if (jsonObj.length === 0) {
      var items = {};

      items.value = '0';
      items.code = '0';
      items.product = $('#currentProductCode').val();
      items.entryNumber = $('#currentEntryNumber').val();

      if ($('#addToCartForm' + $('#currentProductCode').val()).find('.qty').val()) {
        items.quantity = $('#addToCartForm' + $('#currentProductCode').val()).find('.qty').val();
      } else {
        items.quantity = $('#addToCartForm').find('.qty').val();
      }

      items.termsAndCondition = termsAndCondition;
      items.acceptedLanguage = acceptedLanguage;
      jsonObj.push(items);
    }

    $('#cboxLoadingGraphic').show();
    $('#cboxLoadingOverlay').show();
    $.ajax({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      type: 'POST',
      url: document.querySelector('.ph-setCharacteristics').textContent,
      dataType: 'json',
      data: JSON.stringify(jsonObj),
      success: function(cartResult, statusText, xhr) {
        $('#cboxLoadingGraphic').hide();
        $('#cboxLoadingOverlay').hide();
        parent.$.colorbox.close();

        if ($('#addToCartForm' + $('#currentProductCode').val())) {
          ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, $('#addToCartForm' + $('#currentProductCode').val()));
        } else {
          ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, $('#addToCartForm'));
        }
      }
    });
  },
  clearSelectedVariants: function() {
    $('.ph-group_selectbox_items select').each(function() {
      $(this).parent().removeClass('ph-config-errorborder');
      $(this).val('');
    });
    $('#decisionPageProductConfiguration').find('.ph-firstproduct-language__validation').hide();
    $('#decisionPageProductConfiguration').find('.ph-existinglanguage__validation').hide();
    $('#decisionPageProductConfiguration').find('.ph-nonlocalanguage__validation').hide();
    $('#decisionPageProductConfiguration').find('.ph-language__termsvalidation').hide();
    $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
    $('.ph-configuration-popup').find('.ph-dspagechbox-languageterms').prop('checked', false);
    $.colorbox.close();
  }
};
